import { ArrowUpRight } from 'lucide-react'

import { StatusPill, type StatusTone } from '@/components/px/StatusPill'

/**
 * LOCKED — the agent-run row: status · what · when · view run ↗
 * (meridian's furniture, a round-1 named borrow). Every run is reachable —
 * "the run is logged" is never prose-only (avoid-list #5). The link target is
 * a real route (usually the surface's own run log anchor).
 */
export function AgentRunRow({
  tone,
  label,
  text,
  time,
  runHref,
  action,
}: {
  tone: StatusTone
  label: string
  text: React.ReactNode
  time: string
  runHref: string
  action?: React.ReactNode
}) {
  return (
    <div className="v-row flex items-center gap-3 py-2.5">
      <StatusPill tone={tone}>{label}</StatusPill>
      <div className="min-w-0 flex-1 text-sm text-foreground">{text}</div>
      {action}
      <div className="v-figure shrink-0 font-mono text-xs text-muted-foreground">{time}</div>
      <a
        href={runHref}
        className="inline-flex shrink-0 items-center gap-0.5 text-xs font-medium text-accent-foreground hover:underline"
      >
        view run
        <ArrowUpRight className="h-3 w-3" aria-hidden />
      </a>
    </div>
  )
}
